import * as ActionTypes from 'src/constants/ActionTypes';
import { IStateAuth } from 'src/entity/StateEntity';
import { ILoginParam, ILoginResult, IUserRule } from 'src/entity/LoginParam';
import LoginService from 'src/services/LoginService';
import { Dispatch } from 'redux';
import { RouterConfig } from 'src/routers/urlConfig';
import { message } from 'antd';
import I18N from 'src/services/I18NService';
import * as persisStore from 'src/redux/store';

function loginSuccess(state: IStateAuth, authResult: ILoginResult): IStateAuth {
  return Object.assign(state, {
    isLogin: true,
    accessToken: authResult.access_token,
    menuItem: getMenuItems(authResult.extra_data),
    type: ActionTypes.LOGIN_SUCCESS,
  });
}

function loginFailure(): IStateAuth {
  return {
    isLogin: false,
    accessToken: undefined,
    menuItem: getMenuItems(undefined),
    type: ActionTypes.LOGIN_FAILURE,
  };
}

function logoutSuccess(state: IStateAuth): IStateAuth {
  return Object.assign(state, {
    isLogin: false,
    accessToken: undefined,
    menuItem: getMenuItems(undefined),
    type: ActionTypes.LOGOUT_SUCCESS,
  });
}

function logoutFailure(state: IStateAuth): IStateAuth {
  return Object.assign(state, {
    isLogin: true,
    type: ActionTypes.LOGOUT_FAILURE,
  });
}

export function clearLogin(): IStateAuth {
  return {
    isLogin: false,
    accessToken: undefined,
    menuItem: getMenuItems(undefined),
    type: ActionTypes.NOT_LOGGED_IN,
  };
}

function getMenuItems(extraData: IUserRule | undefined): RouterConfig.IMenuItems {
  let menuItems: RouterConfig.IMenuData[] = [];

  if (!!extraData) {
    const sourceList = extraData.functions || [];
    const isTrue = RouterConfig.checkMenuItems(sourceList);
    if (!!isTrue && !!sourceList && sourceList.length > 0) {
      menuItems = sourceList;
    }
  }

  // 要求登录的时候如果没有返回菜单，那么就不显示 @20200618
  // if (menuItems.length === 0) {
  //   menuItems = RouterConfig.MenuItems.menus;
  // }

  return {
    menus: menuItems,
    others: RouterConfig.MenuItems.others,
  };
}

export function userLogin(authRequest: ILoginParam): any {
  // (dispatch: Dispatch<IStateAuth>, getState: any) => Promise<boolean>
  return async (dispatch: Dispatch<IStateAuth>, getState: any): Promise<boolean> => {
    try {
      const { authState } = getState();
      const authResult = await LoginService.userLogin(authRequest);
      if (!!authResult) {
        dispatch(loginSuccess(authState, authResult));
        return true;
      } else {
        dispatch(loginFailure());
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_login_failure'));
      }
    }
    return false;
  };
}

export function userLogout(): any {
  return async (dispatch: Dispatch<IStateAuth>) => {
    const { store } = persisStore;
    const { authState } = store.getState();
    return LoginService.agentLogout()
      .then(() => {
        dispatch(logoutSuccess(authState));
      })
      .catch(error => dispatch(logoutFailure(authState)));
  };
}

export function initStore(): any {
  return async (dispatch: Dispatch<IStateAuth>) => {
    const { store } = persisStore;
    const { authState } = store.getState();
    return dispatch(logoutSuccess(authState));
  };
}

export const getAccessToken = (): string | undefined => {
  const { store } = persisStore;
  const { authState } = store.getState();
  if (!!authState && !!authState.isLogin && !!authState.accessToken) {
    return authState.accessToken;
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./src/redux/actions/authCreator.ts